<script setup>
import { ref, computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { useAlert } from 'dashboard/composables';

// ============================================================================
// v110: Configurações > CHAT INTERNO — chave geral liga/desliga (pedido do
// Kairo 07/07). Desligado: o balão some pra TODOS os usuários e o polling
// PARA (alívio de carga). Escrita: SÓ o id 1 (backend valida).
// ============================================================================

/* global axios */
const route = useRoute();
const base = computed(
  () => `/api/v1/accounts/${route.params.accountId}/internal_chat`
);

const isLoading = ref(false);
const salvando = ref(false);
const ativo = ref(true);
const error = ref('');

const load = async () => {
  isLoading.value = true;
  try {
    const { data } = await axios.get(`${base.value}/status`);
    ativo.value = data.ativo;
  } catch (e) {
    error.value = e.response?.data?.error || e.message;
  } finally {
    isLoading.value = false;
  }
};

const alternar = async () => {
  salvando.value = true;
  try {
    const { data } = await axios.post(`${base.value}/toggle`, {
      ativo: !ativo.value,
    });
    ativo.value = data.ativo;
    useAlert(
      ativo.value
        ? '💬 Chat interno LIGADO — o balão volta a aparecer (F5 nas telas abertas)'
        : '🔌 Chat interno DESLIGADO — some pra todos em até 1 minuto'
    );
  } catch (e) {
    useAlert(
      e.response?.status === 403
        ? 'Apenas o administrador principal pode alterar.'
        : `Erro: ${e.message}`
    );
  } finally {
    salvando.value = false;
  }
};

onMounted(load);
</script>

<!-- eslint-disable vue/no-bare-strings-in-template -->
<template>
  <div class="flex-1 p-6 overflow-auto">
    <h1 class="text-xl font-semibold text-n-slate-12">Chat Interno</h1>
    <p class="mt-1 text-sm text-n-slate-11">
      O chat entre colaboradores (balão no canto da tela).
    </p>

    <p v-if="error" class="p-3 mt-4 text-sm rounded-lg border border-n-ruby-7 bg-n-ruby-2 text-n-ruby-11">
      {{ error }}
    </p>

    <div v-if="isLoading" class="py-10 text-center text-n-slate-11">
      <span class="inline-block i-lucide-loader-circle animate-spin size-6" />
    </div>

    <div v-else class="ci-card" :class="ativo ? 'on' : 'off'">
      <div class="flex-1">
        <p class="text-sm font-bold text-n-slate-12">Chave geral do chat interno</p>
        <p class="mt-1 text-xs text-n-slate-11">
          {{ ativo
            ? 'LIGADO — o balão aparece e os colaboradores conversam entre si.'
            : 'DESLIGADO — o balão some pra TODOS e as consultas param (menos carga no servidor).' }}
        </p>
        <p class="mt-2 text-[11px] text-n-slate-11">
          O efeito vale em até 1 minuto pras telas abertas (no próximo ciclo do widget).
        </p>
      </div>
      <button
        type="button"
        class="ci-switch"
        :class="{ on: ativo }"
        :disabled="salvando"
        @click="alternar"
      >
        <span class="ci-bola" />
        <b>{{ ativo ? 'LIGADO' : 'DESLIGADO' }}</b>
      </button>
    </div>
  </div>
</template>

<style scoped>
.ci-card {
  display: flex;
  gap: 16px;
  align-items: center;
  margin-top: 16px;
  padding: 18px;
  max-width: 640px;
  border-radius: 16px;
  border: 2px solid;
  background: linear-gradient(180deg, #17181d, #111216);
}
.ci-card.on { border-color: #25d366; box-shadow: 0 0 0 2px rgba(37, 211, 102, 0.18); }
.ci-card.off { border-color: #3a3d45; }
.ci-switch {
  display: inline-flex;
  gap: 10px;
  align-items: center;
  padding: 8px 14px 8px 8px;
  border: none;
  border-radius: 999px;
  background: #3a3d45;
  color: #cbd5e1;
  font-size: 12px;
  cursor: pointer;
  transition: background 0.15s ease;
}
.ci-switch.on { background: #25d366; color: #06301a; }
.ci-bola {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #fff;
}
</style>
